// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_Imgs from "../Visonum.BulkPingApp.Imgs/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var select = /* #__PURE__ */ Halogen_Styled_DSL.select();
var eq = /* #__PURE__ */ Data_Eq.eq(Visonum_BulkPingApp_Components_App_Types.eqLogInState);
var view = function (state) {
    var elVfLogo = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("VfLogo")([ inline({
        width: "40px",
        height: "40px"
    }) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Header")([ inline({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: "15px"
    }) ]);
    var elLogoutIcon = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("Logout")([ inline({
        width: "40px",
        height: "40px",
        cursor: "pointer",
        borderRadius: "50%",
        padding: "10px"
    }), Halogen_Styled_DSL.scopedSheet(select(":hover")({
        backgroundColor: "rgba(0,0,0,0.05)"
    })) ]);
    var elLogo = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Logo")([ inline({
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center"
    }) ]);
    var elBmpLogo = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("BmpLogo")([ inline({
        height: "30px",
        justifySelf: "start",
        flex: "1"
    }) ]);
    return elRoot([ Halogen_HTML_Events.onClick(Data_Function["const"](Visonum_BulkPingApp_Components_App_Types.HideDetails.value)) ])([ elLogo([  ])([ elVfLogo([ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgVfLogo) ]), elBmpLogo([ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgBmpLogo) ]) ]), (function () {
        var $3 = eq(state.logInState)(Visonum_BulkPingApp_Components_App_Types.LoginSuccess.value);
        if ($3) {
            return elLogoutIcon([ Halogen_HTML_Events.onClick(Data_Function["const"](Visonum_BulkPingApp_Components_App_Types.Logout.value)), Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgLogout) ]);
        };
        return Halogen_Styled.text("");
    })() ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
